import { lazy } from "react"
import { Navigate } from "react-router-dom"

import { companyEnergyAuditCurrentRoutes } from "@/pages/dashboard/company-energy-audit/current/routes.tsx"
import { companyEnergyAuditHistoryRoutes } from "@/pages/dashboard/company-energy-audit/history/routes.ts"
import { COMPANY_BASE_ROLES_VALUES } from "@/shared/constants"
import type { CustomRoute } from "@/shared/types"

const CompanyEnergyAuditWrapper = lazy(async () => import("@/features/energy-audit/components/company-energy-audit-wrapper"))

export const companyEnergyAuditRoutes: CustomRoute = {
  path: "company-energy-audit",
  handle: {
    label: "Энергоаудит",
    i18Key: "energy-audit",
    icon: "ChartBubble",
    ignoreChildren: true,
    allowedRoles: COMPANY_BASE_ROLES_VALUES,
    allowedPermissions: ["energyaudit_view"]
  },
  children: [
    {
      element: <CompanyEnergyAuditWrapper />,
      children: [
        {
          index: true,
          element: <Navigate to="current" replace />
        },
        companyEnergyAuditCurrentRoutes,
        companyEnergyAuditHistoryRoutes
      ]
    }
  ]
}
